export const URL_PARAMS_KEYS = {
  next: "next",
};
